// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__zTOPn","spin":"styles_spin__a1heO"};